<template>
  <div class="notice-container">
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-card>
            <div slot="header" class="com_header">
              <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="公告标题">
                  <el-input v-model="formInline.title" placeholder="请输入公告标题"></el-input>
                </el-form-item>
                <el-form-item label="公告类型">
                  <el-select v-model="formInline.noticeType" placeholder="请选择公告类型">
                    <el-option v-for="item in noticeTypeDict" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
              </el-form>
              <el-button type="primary" @click="anchor()">发布公告</el-button>
            </div>
            <div v-loading="loading" class="com_cont">
              <el-table :data="tableData" border>
                <el-table-column label="公告标题" prop="title" align="center"></el-table-column>
                <el-table-column label="发布时间" prop="createDate" align="center"
                  :formatter="dateFormat"></el-table-column>
                <el-table-column label="公告类型" prop="noticeType" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.noticeType ? noticeTypeDict.find(it => it.value === scope.row.noticeType).label :
                      '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="公告内容" prop="content" align="center"></el-table-column>
                <el-table-column align="center" label='操作' width="100">
                  <template slot-scope="scope">
                    <el-popconfirm title="确定要删除吗？" @confirm="handleDelete(scope.row)">
                      <el-button slot="reference" type="text" size="small">删除</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
              <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagination.pageSize"
                  layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
                </el-pagination>
              </div>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
    <el-drawer title="发布公告" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" label-position="left"
        class="demo-ruleForm">
        <el-form-item label="请输入公告标题" prop="title">
          <el-input v-model="ruleForm.title" placeholder="请输入公告标题"></el-input>
        </el-form-item>
        <el-form-item label="公告类型" prop="noticeType">
          <el-select v-model="ruleForm.noticeType" placeholder="请选择公告类型" style="width: 100%;">
            <el-option v-for="item in noticeTypeDict" :key="item.value" :label="item.label" :value="item.value">{{
              item.label }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公告内容" prop="content">
          <el-input type="textarea" :rows="10" v-model="ruleForm.content" placeholder="请输入公告内容"></el-input>
        </el-form-item>
        <el-form-item style="width:100%;display:flex;justify-content:center;">
          <el-button @click="resetForm('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')" :loading="drawerLoading">{{ drawerLoading ? '提交中...'
            :
            '确定'
            }}</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { postdataNotice, noticeList, deleteNotice } from '@/api/publicManagement'
import { noticeTypeDict } from '@/data/constant'
import moment from "moment";
export default {
  name: 'AdminStaticsAnnounce',

  mounted() {
    this.notices()
  },
  data() {
    return {
      formInline: {
        title: '',
        noticeType: ''
      },
      noticeTypeDict,
      drawer: false,
      value3: '',
      loading: false,
      activeName: '1',
      tableData: [],
      isDisabled: false,
      page: {
        index: 0,
        sizes: [10, 20, 30, 40],
      },
      formData: {},
      // 分页传参
      pageObj: {
        pageNo: 0,
        pageSize: 10,
      },
      pagination: {
        currentPage: 1, // 当前页
        pageSize: 10, // 每页显示条数
        total: 0, // 总条数
        layout: 'total, prev, pager, next, jumper', // 分页布局
      },
      ruleForm: {
        title: '',
        content: '',
        noticeType: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入公告标题', trigger: 'blur' },
        ],
        noticeType: [
          { required: true, message: '请选择公告类型', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请填写公告内容', trigger: 'blur' }
        ]
      },
      drawerLoading: false
    };
  },
  methods: {
    // 时间转换
    dateFormat(row) {
      return moment(row.createDate).format('YYYY-MM-DD HH:mm:ss');
    },
    // 重置formData
    reData() {
      this.formData = {};
    },
    // 切换页码
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.notice()
    },
    // 切换每页条目数
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.notice()
    },
    // 查询
    onSubmit() {
      this.pagination.currentPage = 1
      this.notices()
    },
    // 公告分页查询
    async notices() {
      this.loading = true
      const params = {}

      if (this.formInline.title) {
        params.title = this.formInline.title
      }

      if (this.formInline.noticeType) {
        params.noticeType = this.formInline.noticeType
      }

      await noticeList({
        pageNo: this.pagination.currentPage - 1,
        pageSize: this.pagination.pageSize,
        ...params
      }).then((res) => {
        this.loading = false
        this.tableData = res.data.content
        this.pagination.total = res.data.totalElements
      }).catch(() => {
        this.loading = false
      })
    },
    // 发布公告
    anchor() {
      this.drawer = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.drawerLoading = true
          postdataNotice({
            ...this.ruleForm,
            memberId: 0,
          }).then(() => {
            this.drawerLoading = false
            this.$message.success('发布成功')
            this.drawer = false
            this.notices()
            this.ruleForm = {}
          }).catch(() => {
            this.drawerLoading = false
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.drawer = false
      this.$refs[formName].resetFields();
    },
    handleDelete(row) {
      deleteNotice({
        id: row.noticeId
      }).then(() => {
        this.$message.success('删除成功')
        this.notices()
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.notice-container {
  height: 100%;
}

.grid-content {
  display: flex;
  flex-direction: column;
}

.com_header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

::v-deep .el-card {
  height: 100% !important;
}

::v-deep .el-card__header {
  padding: 24px 16px 0 !important;
}

::v-deep .el-card__body {
  height: calc(100% - 117px) !important;
}

.pagination-container {
  margin-top: 16px;
  text-align: right;
}



.com_cont {
  height: 100% !important;
}

::v-deep .el-empty {
  height: 90%;
}

::v-deep .el-drawer__body {
  padding: 0 16px;
}
</style>